export const STORAGE_KEYS = {
  AUTH: {
    TOKEN: "auth-storage",
  },
  UI: {
    THEME: "theme",
    SIDEBAR: "neotim-ui",
  },
  USER: {
    SETTINGS: "neotim-user-settings",
    PERMISSIONS: "neotim_permissions",
    STORAGE: "user-storage",
  },
  FEATURES: {
    GLOBAL_SEARCH: {
      STORAGE: "global-search-storage",
      RECENT_COMMANDS: "neotim_command_recent",
      RECENT_SEARCHES: "neotim_recent_searches",
    },
    DOCUMENT_MANAGER: "document-manager-storage",
    CONTRAT_DRAFT: "contrat-draft-storage",
    POINTAGE: {
      MANUAL_MODE_OVERRIDE: "neotim_manual_mode_override",
    },
  },
} as const;
